import { styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const NotificationPill = styled(TextV2)`
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f16e00;
  border: solid 1px #f16e00;
  border-radius: 24px;
  letter-spacing: -0.032px;
  padding: 3px 8px;
  font-size: ${pxToRem(13)};
  height: ${pxToRem(18)};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    font-size: ${pxToRem(10)};
    padding: 1px 5px;
    line-height: 1.4;
  }
`;
